import React from 'react';
import PropTypes from 'prop-types';

import { SiteConfigManager } from '@atlas/core';
import { clientProfileRoutes, COMPONENT_TYPES } from '@atlas/routing';

import BonusDetailController from './BonusDetail/BonusDetailController';
import CombinedBonusesView from './CombinedBonuses/CombinedBonusesView';
import useCombinedBonuses from './CombinedBonuses/useCombinedBonuses';

const { CLIENT_PROFILE } = COMPONENT_TYPES;
const { bonuses } = clientProfileRoutes;

const BonusesFeedRoute = ({ match }) => {
  const bonusId = match?.params?.bonusId;
  const feed = useCombinedBonuses();

  const clientProfilePath = SiteConfigManager.getComponentPath(CLIENT_PROFILE);
  const listUrl = `${clientProfilePath}/${bonuses}`;

  if (bonusId) {
    return (
      <BonusDetailController
        activateBonus={feed.activateBonus}
        activateFreespin={feed.activateFreespin}
        availableTemplates={feed.availableTemplates}
        bonusId={bonusId}
        cancelFreespin={feed.cancelFreespin}
        clientBonuses={feed.clientBonuses}
        deactivateBonus={feed.deactivateBonus}
        freespins={feed.freespins}
        listUrl={listUrl}
        loading={feed.loading}
      />
    );
  }

  return <CombinedBonusesView {...feed} />;
};

BonusesFeedRoute.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      bonusId: PropTypes.string,
    }),
  }),
};

export default BonusesFeedRoute;
